export const USER_DATA = "@user/user_data";
export const USER_UUID = "@user/user_uuid";
export const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

export const colors = {
  primary: "#0097ff",
  secondary: "#ECF1FE",
  background: "#F9F9F9EE",
  white: "#FFFFFF",
  black: "#191A1BFF",
  status: {
    red: "#E33939FF",
    green: "#4DD04DFF",
    yellow: "#FBC525FF",
    blue: "#0000FF",
  }
}